;(function () {
  'use strict'

  // Includes data-autoplay videos: these intentionally omit the native
  // autoplay attribute so the browser does not decode them all up front.
  // The IntersectionObserver below starts playback once they near the
  // viewport and pauses them when they leave.
  const SELECTOR = '.video video[autoplay], .video video[data-autoplay]'
  const videos = () => Array.from(document.querySelectorAll(SELECTOR))

  let observer = null

  const safePlay = async (v) => {
    try {
      v.muted = true
      v.playsInline = true

      if (v.readyState === 0) {
        v.load()
      }

      const p = v.play()
      if (p && typeof p.then === 'function') {
        await p
      }
    } catch (e) {}
  }

  const hardResumeIfFrozen = async (list) => {
    const samples = list.map((v) => ({ v, t: v.currentTime }))
    await new Promise((r) => setTimeout(r, 200))

    for (const s of samples) {
      const v = s.v
      if (!v) continue

      const advanced = v.currentTime > s.t + 0.01
      if (!advanced) {
        try {
          v.pause()
        } catch (e) {}
        try {
          v.load()
        } catch (e) {}
        await safePlay(v)
      }
    }
  }

  const resumeVisibleVideos = async () => {
    const list = videos().filter((v) => !v.paused)
    if (!list.length) return

    for (const v of list) {
      await safePlay(v)
    }

    await hardResumeIfFrozen(list)
  }

  const setupIntersectionObserver = () => {
    if (!('IntersectionObserver' in window)) return

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            safePlay(target)
          } else {
            try {
              target.pause()
            } catch (e) {}
          }
        })
      },
      {
        rootMargin: '250px 0px',
        threshold: 0.01,
      }
    )

    videos().forEach((v) => observer.observe(v))
  }

  const init = () => {
    setupIntersectionObserver()
    resumeVisibleVideos()
  }

  // Page lifecycle hooks (CRITICAL for iOS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      resumeVisibleVideos()
    }
  })

  window.addEventListener('pageshow', init)
  window.addEventListener('focus', resumeVisibleVideos)

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    init()
  } else {
    document.addEventListener('DOMContentLoaded', init)
  }
})()
